import React, { useState } from "react";
import {
	BrowserRouter as Router,
	Routes,
	Route,
	useNavigate,
	Link,
} from "react-router-dom";
import "./App.css";
import HomePage from "./screens/HomePage/HomePage";
import PrivacyPolicy from "./screens/PrivacyPolicy/PrivacyPolicy";
import { PageBehaviour } from "./assets/allTypes";
import Games from "./screens/Games/Games";
import Header from "./components/Header/Header";

function App() {
	const [pageBehaviour, setPageBehaviour] = useState<PageBehaviour>("HOME");
	return (
		<Router>
			<div className="App">
				<Header onClickHeaderTab={() => {}} />
				<Routes>
					<Route
						path="/"
						element={
							<HomePage
								pageBehaviour={pageBehaviour}
							/>
						}
					/>
					<Route
						path="/games"
						element={
							<Games
								pageBehaviour={pageBehaviour}
							/>
						}
					/>
					<Route
						path="/privacy-policy"
						element={
							<PrivacyPolicy
								pageBehaviour={pageBehaviour}
							/>
						}
					/>
				</Routes>
			</div>
		</Router>
	);
}

export default App;
